import { routes } from '../../../routes'; // Update the path based on your project structure
import { Flex, Spin, Button as AntButton, App } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { ReactComponent as Back } from '../../../assets/arrow.svg';
import { useMutation, useQuery } from '@tanstack/react-query';
import { createUpdateEmailTemplate, getEmailTemplateById } from './request';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import {
  Bold,
  ClassicEditor,
  Essentials,
  Heading,
  Italic,
  Link,
  List,
  Mention,
  Paragraph,
  Underline,
  Undo,
} from 'ckeditor5';
import { useRef, useState } from 'react';
import Button from '../../../custom/button/button';

const ViewTemplate = () => {
  const params = useParams();
  const { notification } = App.useApp();
  const [changes, setChanges] = useState('');
  const navigate = useNavigate();
  const templateRef = useRef<any>(null);

  const onReady = (editor: any) => {
    templateRef.current = editor;
  };
  const id = params.id;

  const updateTemplateMutation = useMutation({ mutationFn: (payload: FormData) => createUpdateEmailTemplate(payload) });
  const { data, isLoading, refetch } = useQuery({
    queryKey: ['emailTemplate', id],
    queryFn: () => getEmailTemplateById(Number(id)),
  });

  const template = data?.data as EmailTemplate;

  const handleUpdate = async () => {
    try {
      const formData = new FormData();
      if (id) {
        formData.append('Id', id);
      }
      formData.append('Code', template?.code);
      formData.append('Body', changes || template?.body || '');
      formData.append('ActiveStatus', String(template?.activeStatus || true));
      await updateTemplateMutation.mutateAsync(formData, {
        onSuccess: (data) => {
          notification.success({
            message: 'Success',
            description: data?.message || 'Template updated successfully',
          });
          refetch();
        },
      });
    } catch (error: any) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message || 'An error occurred while updating template',
      });
    }
  };

  if (isLoading) {
    return <Spin />;
  }

  return (
    <div>
      <Flex align="center" gap="8px">
        <AntButton onClick={() => navigate(routes.userMgt.emailTemplates)} variant="text">
          <Back />
        </AntButton>
        <h3>{template?.code}</h3>
      </Flex>
      <br />
      <div className="fields">
        <CKEditor
          editor={ClassicEditor}
          config={{
            toolbar: {
              items: [
                'heading',
                'undo',
                'redo',
                '|',
                'bold',
                'italic',
                'underline',
                'link',
                '|',
                'numberedList',
                'bulletedList',
              ],
            },
            plugins: [Bold, Essentials, Italic, Mention, Paragraph, Undo, Link, List, Heading, Underline],
            initialData: template?.body,
          }}
          onChange={(_, editor) => {
            const data = editor.getData();
            setChanges(data);
          }}
          onReady={onReady}
          data={template?.body || ''}
        />
        <br />
        <Button text="Save Changes" onClick={handleUpdate} isLoading={updateTemplateMutation.isPending} />
      </div>
    </div>
  );
};

export default ViewTemplate;
